import { render } from "./CreateDriver.vue?vue&type=template&id=1565ffa2"
import script from "./CreateDriver.vue?vue&type=script&lang=js"
export * from "./CreateDriver.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__